<template>
  <div
    id="application"
    class="application"
    :class="`${currentState} ${
      currentState.includes('state-shop-area-') ? 'state-shop-area' : ''
    }`"
  >
    <div
      class="loader"
      style="
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        z-index: 1040;
      "
    >
      <img
        src="/images/loader.svg"
        class="sprd-loader"
        style="width: 100px; height: 100px"
      />
    </div>

    <div class="main-content-container">
      <Navbar />

      <div id="main-content">
        <GlobalToasts />
        <router-view :key="routeViewKey"></router-view>
      </div>

      <HelpPanel />
    </div>

    <DialogWrapper />
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import Navbar from 'src/app/partnerarea/navbar/Navbar.vue';
import DialogWrapper from 'commons/dialogs/wrapper/DialogWrapper.vue';
import GlobalToasts from 'src/app/components/toast/GlobalToasts.vue';
import HelpPanel from 'src/app/components/helpPanel/HelpPanel.vue';
import applicationInitialization from './app/config/applicationInitialization';
import { useApplicationStore } from 'commons/stores/application';

export default {
  name: 'App',
  components: {
    Navbar,
    DialogWrapper,
    HelpPanel,
    GlobalToasts,
  },
  computed: {
    ...mapState(useApplicationStore, ['routeViewKey']),
    currentState() {
      return this.$route.name?.length
        ? `state-${this.$route.name.replace(/\./g, '-')}`
        : '';
    },
  },
  watch: {
    $route: {
      handler(to) {
        if (to.meta.reuse === false) {
          this.setRouteViewKey(to.path);
        } else {
          this.setRouteViewKey(undefined);
        }
      },
      immediate: true,
    },
  },
  created() {
    applicationInitialization.onAppStart();
  },
  methods: {
    ...mapActions(useApplicationStore, ['setRouteViewKey']),
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/animations';
@import 'scss/styleguide/colors';
@import 'scss/styleguide/mixins/media';
@import 'scss/styleguide/type';
@import 'scss/utils';

#main-content {
  position: relative;
}

#main-content > div {
  height: 100%;
}
</style>
